import {
    FULL_REPORT_SET_LIST,
    FULL_REPORT_SET_LOADING
} from "actions/actionTypes";


const initialState = {
    loading: false,
    list: [],
    count: 0,
    more: false,

    perPage: 20,
    page: 1
};


const handlers = {
    [FULL_REPORT_SET_LOADING]: (state, { payload }) => ({ ...state, loading: payload }),
    [FULL_REPORT_SET_LIST]: (state, { payload }) => ({ ...state, ...payload, loading: false }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action)
};
